import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import TransitionContainer from '../../components/Transition/TranstionContainer';
import CssTransition from '../../components/Transition/CssTransition';
import { TransitionGroup } from 'react-transition-group';

import ToasterAlert from '../../components/Donation/ToasterAlert';

import CheckRegistrationForm from '../../components/CheckRegistration/CheckRegistrationForm';

import { getActionCompletedTime } from '../../utils/actionTiming';
import { CardTypes } from '../../utils/enums';
import {
    getNextAction,
    buildConditionalActionsAnswerHistory
} from '../../utils/nextActionUtil';
import { handleSkippingEndCard } from '../../utils/handleSkippingEndCard';

import {
    ContainerStyled,
    LegalInfoWrapper,
    FormWrapper
} from '../../containers/DefaultStyles/AssessmentDetails';

import VoteRegistrationSidebar from '../../components/VoteRegistration/VoteRegistrationSidebar';

import LegalInfo from '../../components/Widget/LegalInfo';

import { onGoToNextCard } from '../Widget/actions';
import { onGoToStartScreen, submitCheckRegistrationForm } from './actions';
import { cacheFormData } from '../../utils/formCaching/actions';

const CheckRegistrationDetails = props => (
    <TransitionContainer isSubmitting={props.isFormSubmitting} zIndex={2}>
        <ContainerStyled>
            <VoteRegistrationSidebar
                title={props.customHeader}
                showReceiveUpdates={true}
            />
            <FormWrapper>
                <CheckRegistrationForm
                    onBack={() => {
                        props.onGoToStartScreen(props.actionIdentifier);
                    }}
                    onSubmit={values => {
                        props.cacheFormData(values);
                        if (props.skipEndCard) {
                            props.handleSkippingEndCard(
                                props.nextAction,
                                props.cards,
                                props.onGoToNextCard
                            );
                        }
                        props.submitCheckRegistrationForm(
                            props.apiRequestData,
                            values,
                            props.isMultiActionsCard,
                            props.actionIdentifier,
                            props.actionCompletedTime(),
                            props.skipEndCard
                        );
                    }}
                    isFormSubmitting={props.isFormSubmitting}
                />
                {props.isMobileResolution && (
                    <LegalInfoWrapper>
                        <LegalInfo />
                    </LegalInfoWrapper>
                )}
            </FormWrapper>
            <TransitionGroup>
                {props.checkRegistrationError && (
                    <CssTransition key="alert" in={props.checkRegistrationError}>
                        <ToasterAlert content={props.checkRegistrationError} />
                    </CssTransition>
                )}
            </TransitionGroup>
        </ContainerStyled>
    </TransitionContainer>
);

CheckRegistrationDetails.propTypes = {
    nextAction: PropTypes.object,
    customHeader: PropTypes.string,
    isMobileResolution: PropTypes.bool,
    apiRequestData: PropTypes.object.isRequired,
    isFormSubmitting: PropTypes.bool,
    onGoToStartScreen: PropTypes.func.isRequired,
    submitCheckRegistrationForm: PropTypes.func.isRequired,
    checkRegistrationError: PropTypes.string,
    isMultiActionsCard: PropTypes.bool.isRequired,
    actionIdentifier: PropTypes.string.isRequired,
    actionCompletedTime: PropTypes.func.isRequired,
    skipEndCard: PropTypes.bool,
    onGoToNextCard: PropTypes.func.isRequired,
    handleSkippingEndCard: PropTypes.func.isRequired,
    cards: PropTypes.array.isRequired,
    cacheFormData: PropTypes.func.isRequired
};

export default connect(
    state => {
        const nextAction = getNextAction(
            state.widget.actions,
            state.widget.activeAction.identifier,
            buildConditionalActionsAnswerHistory(state),
            state.widget.cards
        );

        return {
            nextAction,
            customHeader:
                state.widget.activeAction.customHeader || `Check your registration.`,
            isMobileResolution: state.widget.isMobileResolution,
            apiRequestData: state.widget.apiRequestData,
            isFormSubmitting: state.checkRegistration.isFormSubmitting,
            checkRegistrationError: state.checkRegistration.checkRegistrationError,
            isMultiActionsCard:
                state.widget.cards[state.widget.activeAction.order - 1].type ===
                CardTypes.multipleActions,
            actionIdentifier: state.widget.activeAction.identifier,
            actionCompletedTime: getActionCompletedTime(state, 'checkRegistration'),
            cards: state.widget.cards,
            skipEndCard: state.widget.activeAction.skipEndCard && !!nextAction
        };
    },
    {
        onGoToStartScreen,
        submitCheckRegistrationForm,
        onGoToNextCard,
        handleSkippingEndCard,
        cacheFormData
    }
)(CheckRegistrationDetails);



// WEBPACK FOOTER //
// ./src/containers/CheckRegistration/CheckRegistrationDetails.jsx